import { gate } from 'hub-http/gates';
export const PAYMENT_LINK_NEW_BADGE_PHASE_2 = 'Payments:NewBadgeSPLPhase2';
export const CREATE_SUBSCRIPTION = 'Payments:Subscriptions:CreateSubscription';
export const SINGLE_CONTACT_ASSOCIATION = gate('commerce:invoices:singleContactAssociation');